var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJasmineIntegration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_6352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7584 13.2501H17.2367L17.8523 12.4025V5.76306H14.1429V12.4031L14.7584 13.2501Z",
    fill: "#8A4182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4518 26.1977H16.4797V21.1504H15.4518V26.1977ZM6.28675 19.4922L5.96925 18.5145L10.7691 16.9554L11.0865 17.9331L6.28675 19.4922ZM12.4801 11.8095L9.51404 7.72623L10.346 7.12187L13.3121 11.2054L12.4801 11.8095ZM19.5666 11.847L18.7348 11.2428L21.7012 7.1592L22.5332 7.76329L19.5666 11.847ZM25.6885 19.5536L20.8883 17.9936L21.2059 17.0157L26.0058 18.5757L25.6885 19.5536ZM18.0681 13.8541L18.8342 16.2114L19.8306 16.5347L26.145 14.4833L24.9989 10.9555L18.6839 13.0075L18.0681 13.8541ZM18.519 17.1889L16.5137 18.6456L16.514 19.6929L20.4165 25.0647L23.4178 22.8846L19.5145 17.5125L18.519 17.1889ZM15.4858 18.6461L13.481 17.1889L12.4846 17.5132L8.58205 22.8847L11.5828 25.0647L15.4859 19.693L15.4858 18.6461ZM13.1631 16.2115L13.9288 13.8546L13.313 13.0069L6.99849 10.9552L5.85215 14.483L12.1677 16.5349L13.1631 16.2115ZM16.001 0C7.17868 0 0.000961304 7.17635 0.000961304 15.9973C0.000961304 24.8215 7.17868 32 16.001 32C24.8224 32 31.9991 24.8215 31.9991 15.9973C31.9991 7.17635 24.8224 0 16.001 0ZM16.001 3.23916C23.046 3.23916 28.7596 8.95037 28.7596 15.9973C28.7596 23.0466 23.046 28.7603 16.001 28.7603C8.95324 28.7603 3.24067 23.0466 3.24067 15.9973C3.24067 8.95037 8.95324 3.23916 16.001 3.23916Z",
    fill: "#8A4182"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_6352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJasmineIntegration);
export default __webpack_public_path__ + "static/media/jasmine-integration.4243a72225b4468b26658b769a060f50.svg";
export { ForwardRef as ReactComponent };